import { Spinner } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { CustomDecorativeModal } from '@app/components/Modal';

import styles from './styles.module.scss';

const CheckoutLoading = ({ isOpen }: { isOpen: boolean }): JSX.Element => {
  const { t } = useTranslation('BuyMore');
  const className = styles['customLoading'];

  return (
    <CustomDecorativeModal
      header={undefined}
      isOpen={isOpen}
      actions={{ primary: { label: '', style: { display: 'none' } } }}
      surfaceProps={{ className }}
    >
      <Spinner size="small" className={styles['customSpinner']} description={t('Checkout.loading')} />
    </CustomDecorativeModal>
  );
};

export default CheckoutLoading;
